import React from 'react';
import { mapModifiers, ModifierProp } from 'libs/component';

export interface ShortcutListProps {
  children?: React.ReactNode;
  modifiers?: ModifierProp<'gold' | 'blue' | 'ivory'>;
}

export const ShortcutList: React.FC<ShortcutListProps> = ({ children, modifiers }) => (
  <div className={mapModifiers('m-shortcut-list', modifiers)}>{children}</div>
);
